import { API } from '../../../config';
import { errorHandler } from '../auth/errorAction';

export const unmountListTicket = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_TICKET'})
}

export const unmountDetailTicket = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_TICKET'})
}

export const unmountMasterTicket = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_TICKET'})
}

export const unmountListTicketByXpert = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_TICKET_XPERT'})
}

export const listTicket = (meta) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_TICKET' })
  return API.GET('/xpert/ticket/list', meta).then((response) => {
    dispatch({
      type: 'LOAD_DATA_TICKET_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: response.meta.page,
          total: response.meta.total,
          perpage: response.meta.perpage
        }
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_TICKET_FAILED' }), 
    ))
  })
}

export const detailTicket = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_TICKET' })
  const params = {
    'id': id
  }
  API.GET('/xpert/ticket/getById', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_TICKET_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_TICKET_FAILED' }), 
      ))
    )
  })
}

export const listTicketByXpert = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_TICKET_XPERT' })
  const params = {
    'id': id
  }
  API.GET('/xpert/ticket/getListByXpert', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_TICKET_XPERT_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_TICKET_XPERT_FAILED' }), 
      ))
    )
  })
}

export const masterTicket = (successCB, failedCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_TICKET' })
  return API.GET('/employers_type/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_TICKET_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: null,
          total: null,
          perpage: null
        }
    }})
    return successCB && successCB(response.data)
  }).catch((err) => {
    failedCB && failedCB()
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_MASTER_TICKET_FAILED' }), 
    ))
  })
}

export const createTicket = (value, successCB, failedCB) => () => {
  API.POST_NO_PARAMS('/xpert/ticket/add', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const editTicket = (value, successCB, failedCB) => () => {
  API.POST_NO_PARAMS('/xpert/ticket/update', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const enableTicket = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/xpert/ticket/enable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const disableTicket = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/xpert/ticket/disable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}